/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { DisputeListAPIPayload } from 'screens/Products/Edge/Disputes/typing';
import apiEndpoints from '../lib/apiEndpoints';
import apiCall from './apiCall';

type CancelablePayload<T> = T & { cancelKey?: string };

const stripCancelKey = <T extends Record<string, any>>(payload: T = {} as T) => {
  const { cancelKey, ...requestPayload } = payload;
  return { cancelKey, requestPayload };
};

const sanitizeDisputeListPayload = (payload: DisputeListAPIPayload) => {
  return Object.entries(payload || {}).reduce((acc, [key, value]) => {
    if (value === null || value === undefined) {
      return acc;
    }

    if (typeof value === 'string' && value.trim() === '') {
      return acc;
    }

    acc[key] = value;
    return acc;
  }, {} as Record<string, string | number>);
};

export const getDisputeListAPI = (
  payload: CancelablePayload<DisputeListAPIPayload>
) => {
  const { cancelKey, requestPayload } = stripCancelKey(payload);
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.GET_DISPUTES_LIST}`,
    query: sanitizeDisputeListPayload(requestPayload),
    cancelKey,
  });
};

export const getDisputeDetailsAPI = (
  data: string | { chargebackId: string; cancelKey?: string }
) => {
  const chargebackId = typeof data === 'object' ? data.chargebackId : data;
  const cancelKey = typeof data === 'object' ? data.cancelKey : undefined;
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.GET_DISPUTE_DETAILS(chargebackId)}`,
    cancelKey,
  });
};

export const getEdgeDisputeListDownloadAPI = (
  payload: CancelablePayload<DisputeListAPIPayload>
) => {
  const { cancelKey, requestPayload } = stripCancelKey(payload);
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.GET_DISPUTES_LIST_DOWNLOAD}`,
    query: sanitizeDisputeListPayload(requestPayload),
    cancelKey,
  });
};
export const getDisputeDocumentConfigAPI = (data?: { cancelKey?: string }) => {
  
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.GET_DISPUTE_DOCUMENT_CONFIG}`,
    cancelKey: data?.cancelKey,
  });
};

export const uploadChargebackDocumentAPI = (chargebackId: string, formData: FormData) => {
  return apiCall({
    method: 'post',
    endpoint: `${apiEndpoints.UPLOAD_CHARGEBACK_DOCUMENT(chargebackId)}`,
    payload: formData,
  });
};

export const reUploadChargebackDocumentAPI = (chargebackId: string, formData: FormData) => {
  return apiCall({
    method: 'put',
    endpoint: `${apiEndpoints.REUPLOAD_CHARGEBACK_DOCUMENT(chargebackId)}`,
    payload: formData,
  });
};

export const getDisputesFeatureFlagAPI = () => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_DISPUTES_FEATURE_ENABLED_FLAG,
  });
};
